module.exports = __webpack_public_path__ + "static/img/pro-7-220x294.9197e46.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/pro-7-220x294.jpg
// module id = kjPE
// module chunks = 1